module.exports = __webpack_public_path__ + "img/redEnvelopedRainButtonImage.7947ae8f.png";